export default [
  {
    path: '/app/user-types',
    name: 'UserTypes',
    component: () => import('@/views/User_types/Index.vue'),
    meta: {
      pageTitle: 'nav.userTypes',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
      resource: 'all',
      action: 'manage',
      packageLimit: {
        subject: 'SUBUSERS_MANAGEMENT',
        limit: 1,
      },
    },
  },
  {
    path: '/app/user-types/add',
    name: 'UserTypeAdd',
    component: () => import('@/views/User_types/Add.vue'),
    meta: {
      pageTitle: 'nav.userTypes',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/user-types',
          active: false,
        },
        {
          text: 'breadcrumb.create',
          active: true,
        },
      ],
      resource: 'all',
      action: 'manage',
      packageLimit: {
        subject: 'SUBUSERS_MANAGEMENT',
        limit: 1,
      },
    },
  },
  {
    path: '/app/user-types/edit/:id',
    name: 'UserTypeEdit',
    component: () => import('@/views/User_types/Edit.vue'),
    meta: {
      pageTitle: 'nav.userTypes',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/user-types',
          active: false,
        },
        {
          text: 'breadcrumb.update',
          active: true,
        },
      ],
      resource: 'all',
      action: 'manage',
      packageLimit: {
        subject: 'SUBUSERS_MANAGEMENT',
        limit: 1,
      },
    },
  },
]
